// 3rd
import { Model } from '@vuex-orm/core'

export default class Rank extends Model {
    static entity = 'ranks';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            point_value: this.attr(null),
            icon: this.attr(null),
        }
    }

    // getters
    static getFirst() {
        return Rank.query().whereId(1).withAll().first();
    }
}
